/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export * from "./CosmosPageLegalContent.client";
export * from "./CosmosPageLegalContent.data";
export * from "./CosmosPageLegalContent.page";
